import { render } from "./FeedCard.vue?vue&type=template&id=0570185f&scoped=true"
import script from "./FeedCard.vue?vue&type=script&lang=js"
export * from "./FeedCard.vue?vue&type=script&lang=js"

import "./FeedCard.vue?vue&type=style&index=0&id=0570185f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0570185f"]])

export default __exports__